import '../App.css';
import { Amplify,Auth  } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import awsExports from '../aws-exports';
import React, { createContext, useState, useEffect,  } from 'react';
import { useDataStoreCreateAction, useNavigateAction } from "@aws-amplify/ui-react/internal";
import { Qanswer } from "../models";
import { schema } from "../models/schema";

import Header from '../ui-components/StaticHeader_fix'
import Footer from '../ui-components/Footer_fix'
import QuestionItemHead from '../ui-components/QuestionItemHead_fix'
import QuestionItemCollectionFirst from '../ui-components/QuestionItemCollectionFirst_fix'
import QuestionItemCollectionSecond from '../ui-components/QuestionItemCollectionSecond_fix'
import QuestionItemCollectionThird from '../ui-components/QuestionItemCollectionThird_fix'
import QuestionItemCollectionFourth from '../ui-components/QuestionItemCollectionFourth_fix'
import QuestionItemCollectionFifth from '../ui-components/QuestionItemCollectionFifth_fix'
import QuestionItemCollectionSixth from '../ui-components/QuestionItemCollectionSixth_fix'
import QuestionItemFoot from '../ui-components/QuestionItemFoot_fix'


export const MyContext = createContext();

Amplify.configure(awsExports);

function CheckQuestion() {
  
  const [userAttributes, setUserAttributes] = useState(null);
  const navigateAction = useNavigateAction({ type: "url", url: "/ContentsList" });

useEffect(() => {
  async function fetchUserAttributes() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      // ユーザーの属性を取得
      const attributes = user.attributes;
      setUserAttributes({
        name: attributes.name,
        email: attributes.email,
        birthdate: attributes.birthdate,
        userId: attributes.sub, // ユーザーIDはsub属性に格納されています
      });
    } catch (error) {
      console.error('ユーザー情報の取得に失敗しました: ', error);
      // エラーハンドリングを追加するか、適切にエラーを処理してください。
    }
  }

  fetchUserAttributes();
}, []);


  const [PageNo, setPageNo] = useState(0);
  const [showQuestion, setShowQuestion] = useState(true);
  const [showQuestion2, setShowQuestion2] = useState(false);
  const [showQuestion3, setShowQuestion3] = useState(false);
  const [showQuestion4, setShowQuestion4] = useState(false);
  const [showQuestion5, setShowQuestion5] = useState(false);
  const [showQuestion6, setShowQuestion6] = useState(false);
  const [x, setX] = useState('');
  const [AnsNo1, setAnsNo1] = useState(0);
  const [AnsNo2, setAnsNo2] = useState(0);
  const [AnsNo3, setAnsNo3] = useState(0);
  const [AnsNo4, setAnsNo4] = useState(0);  
  const [AnsNo5, setAnsNo5] = useState(0);
  const [AnsNo6, setAnsNo6] = useState(0);
  
  // 現在の日時を取得
  const now = new Date();

  // 年、月、日、時、分を取得
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const date = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  // "YYYYMMDDHHMM"形式の文字列を作成
  const dateTimeString = `${year}${month}${date}${hours}${minutes}`;

  const createAnsID = (userAttributes?.userId || "defaultUserId") + dateTimeString

  //ダイナモDBへのアップ　QuetionItem2のアップをコメントアウトすること
  const dataStoreCreateAction = useDataStoreCreateAction({
     fields: {
      //PageNo: "3",
    //AnsNo: "3",
      UserID: userAttributes?.userId || "defaultUserId", // nullチェックを追加
      AnsID: createAnsID,
      A01: AnsNo1,
      A02: AnsNo2,
      A03: AnsNo3,
      A04: AnsNo4,
      A05: AnsNo5,
      A06: AnsNo6,
    },
    model: Qanswer,
    schema: schema,
  });

  const handleFrame30Click = () => {
    setShowQuestion(false);
    setShowQuestion2(true);
    setShowQuestion3(false);
    setShowQuestion4(false);
    setShowQuestion5(false);
    setShowQuestion6(false);
    setPageNo(1);
    setX('x value here');
  };

  const handleFrame30Click2 = () => {
    setShowQuestion(false);
    setShowQuestion2(false);
    setShowQuestion3(true);
    setShowQuestion4(false);
    setShowQuestion5(false);
    setShowQuestion6(false);
    setPageNo(2);
    setX('x value here');
  };

  const handleFrame30Click3 = () => {
    setShowQuestion(false);
    setShowQuestion2(false);
    setShowQuestion3(false);
    setShowQuestion4(true);
    setShowQuestion5(false);
    setShowQuestion6(false);
    setPageNo(3);
    setX('x value here');

  };

  const handleFrame30Click4 = () => {
    setShowQuestion2(false);
    setShowQuestion3(false);
    setShowQuestion4(false);
    setShowQuestion5(true);
    setShowQuestion6(false);
    setPageNo(4);
    setX('x value here');

  };

  const handleFrame30Click5 = () => {
    setShowQuestion2(false);
    setShowQuestion3(false);
    setShowQuestion4(false);
    setShowQuestion5(false);
    setShowQuestion6(true);
    setPageNo(5);

  };

  const handleFinalClick = () => {
    setShowQuestion6(false);
    setPageNo(6);
    navigateAction();
    dataStoreCreateAction();
  };
  
  return (
    <div className="ContentsList">
    
     <Header />
      
      <div className="contentmiddle">
      
        <MyContext.Provider value={PageNo}>
          {showQuestion && (
          <>
            <QuestionItemHead
              overrides={{
              "text39455121": {
              children: "どのレベルの内容を求めていますか"
              },
              questionNo:{
               children:"Q1"
              }
            }}/>
          <QuestionItemCollectionFirst
            overrideItems={({ item, index}) => ({
              onClick: () => {
                setPageNo(item.SortNumber);
                setX(item.SortNumber);
                setAnsNo1(item.SortNumber);
              }
            })}
          />
        </>
        )}
        {showQuestion2 && !showQuestion3 && (
        <>
          <QuestionItemHead
        overrides={{
          "text39455121": {
            children: "次の内どの生徒にアプローチしたいですか"
            },
             questionNo:{
               children:"Q2"
             }
        }}/>
          <QuestionItemCollectionSecond
             overrideItems={({ item, index}) => ({
              style: { cursor: "pointer"},
              onClick: () => {
                setPageNo(item.SortNumber);
                setX(item.SortNumber);
                setAnsNo2(item.SortNumber);
              }
            })}/>
        </>
        )}
        {showQuestion3 && !showQuestion4 && (
        <>
          <QuestionItemHead
         overrides={{
          "text39455121": {
            children:"1つの授業で対象とする生徒数は何人ですか",
          },
          questionNo:{
             children:"Q3"
          }
          }}/>
          <QuestionItemCollectionThird 
             overrideItems={({ item, index}) => ({
              style: { cursor: "pointer"},
              onClick: () => {
                setPageNo(item.SortNumber);
                setX(item.SortNumber);
                setAnsNo3(item.SortNumber);
              }
            })}/>
         </>
        )}
        {showQuestion4 && !showQuestion5 && (
        <>
          <QuestionItemHead
         overrides={{
          "text39455121": {
            children:"あなたが授業でよく使うツールを教えてください",
          },
          questionNo:{
             children:"Q4"
          }
          }}/>
          <QuestionItemCollectionFourth
              overrideItems={({ item, index}) => ({
              style: { cursor: "pointer"},
              onClick: () => {
                setPageNo(item.SortNumber);
                setX(item.SortNumber);
                setAnsNo4(item.SortNumber);
              }
            })}/>
       </>
        )}
        {showQuestion5 && !showQuestion6 && (
        <>
          <QuestionItemHead
         overrides={{
          "text39455121": {
             children:"あなたがよく行う授業スタイルを教えてください",
          },
          questionNo:{
             children:"Q5"
          }
          }}/>
          <QuestionItemCollectionFifth
            overrideItems={({ item, index}) => ({
              style: { cursor: "pointer"},
              onClick: () => {
                setPageNo(item.SortNumber);
                setX(item.SortNumber);
                setAnsNo5(item.SortNumber);
              }
            })}/>
        </>
        )}
        {showQuestion6 && (
         <>
          <QuestionItemHead
          
        overrides={{
          "text39455121": {
            children:"このアプリに求めることは何ですか",
          },
          questionNo:{
             children:"Q6"
          }
          }}/>
          <QuestionItemCollectionSixth
          
             overrideItems={({ item, index}) => ({
              style: { cursor: "pointer"},
              onClick: () => {
                setPageNo(item.SortNumber);
                setX(item.SortNumber);
                setAnsNo6(item.SortNumber);
              }
            })}/>
          </>
        )}
        <QuestionItemFoot
          overrides={{
            "Frame 30": {
              onClick: showQuestion ? handleFrame30Click : showQuestion2 ? handleFrame30Click2 : showQuestion3 ? handleFrame30Click3 : showQuestion4 ? handleFrame30Click4 :showQuestion5 ? handleFrame30Click5:  handleFinalClick
            },    
            "Frame 31": {
              onClick: useNavigateAction({ type: "url", url: "/CheckStart" })
            },
            "text39455125": {
               children: "診断キャンセル"
            },
            "text39455127": {
               children: showQuestion6 ? "診断結果へ ＞" : "次の診断へ"
            }
          }}
        />
        </MyContext.Provider>
      </div>

      <Footer />
      
    </div>
  );
}

export default CheckQuestion;